import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaBorderRadius, YodaColors, YodaFontSize, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const sideContainerStyleFirstBox: SxProps<Theme> = () => ({
  backgroundColor: YodaColors.white,
  padding: '24px',
  boxShadow: `0px 5px 20px ${YodaColors.gray2}`,
  borderRadius: YodaBorderRadius.medium,
  border: 'none',
  overflow: 'visible',
});

export const sideContainerStyleInnerBox: SxProps<Theme> = () => ({
  '& > div:last-child': {
    marginBottom: YodaSpacing.none,
  },
});

export const headerWrapperStyle = {
  height: '48px',
  marginBottom: '32px',
  display: 'flex',
  justifyContent: YodaJustifyContent.spaceBetween,
  alignItems: YodaJustifyContent.center,

  '& .MuiBox-root': {
    marginBottom: 0,
  },
};

export const buttonStyle = {
  justifyContent: 'start',
  marginBottom: YodaSpacing.small,
  fontSize: YodaFontSize.small,
  color: YodaColors.blue7,
  width: 'fit-content',

  '&:hover': {
    color: YodaColors.blue8,
  },
};
